"use strict";

(function (a, b) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = b() : "function" == typeof define && define.amd ? define(b) : (a = "undefined" == typeof globalThis ? a || self : globalThis, a.Clerk = b());
})(void 0, function () {
  "use strict";

  const a = "1.1.0",
        b = a => {
    var b = String.fromCharCode,
        c = Math.floor;
    const d = a.length;
    let e,
        f = "";

    for (let g = 0; g < d; g++) e = b(97 + c(25 * Math.random())), f += a[g] + e;

    return f;
  },
        c = function () {
    for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
      a[_key] = arguments[_key];
    }

    return a.filter(Boolean).join(" ");
  },
        d = _ref => {
    let {
      for_id: a,
      class_name: b,
      extra_classes: d
    } = _ref;
    const e = document.createElement("label");
    return e.for = a, e.className = c(b, d), e;
  },
        e = _ref2 => {
    let {
      id: a,
      type: b,
      name: d,
      class_name: e,
      extra_classes: f
    } = _ref2;
    const g = document.createElement("textarea");
    return g.id = a, g.name = d, g.className = c(e, f), g.autocomplete = "false", g.tabindex = -1, g;
  },
        f = _ref3 => {
    let {
      class_name: a,
      name: c
    } = _ref3;
    const d = document.createElement("input");
    return d.className = a, d.name = b(c), d.type = "hidden", d.value = 0, d;
  },
        g = _ref4 => {
    let {
      class_name: a,
      name: c
    } = _ref4;
    const d = document.createElement("input");
    return d.className = a, d.name = b(c), d.type = "hidden", d;
  },
        h = function () {
    let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const c = !b.hasOwnProperty("autobind") || b.autobind,
          {
      id: d,
      field_prefix: e = "clerk-field",
      label_prefix: f = "clerk-label"
    } = b.stylesheet || {},
          {
      id: i = "comment",
      class: g,
      extra_classes: h
    } = b.field || {},
          {
      class: j,
      extra_classes: k
    } = b.label || {},
          {
      class: l,
      name: m = "timer"
    } = b.timer || {},
          {
      class: n,
      name: o = "version"
    } = b.version || {},
          p = g || `${e}__${i}`,
          q = j || `${f}__${i}`;
    return {
      autobind: c,
      style: {
        id: d,
        field_prefix: e,
        label_prefix: f,
        field_class_name: p,
        label_class_name: q
      },
      honeypot: {
        field: {
          id: i,
          name: "comment",
          class_name: p,
          extra_classes: h
        },
        label: {
          for_id: i,
          class_name: q,
          extra_classes: k
        },
        timer: {
          class_name: l || `${e}__${m}`,
          name: m
        },
        version: {
          version: a,
          class_name: n || `${e}__${o}`,
          name: o
        }
      }
    };
  };

  class i {
    constructor(a) {
      this.sheet = a ? document.getElementById(a) : this.create_sheet();
    }

    create_sheet() {
      var a = document.createElement("style"); // WebKit hack :(

      return a.appendChild(document.createTextNode("")), document.head.appendChild(a), a.sheet;
    }

    add_rule(a, b) {
      "insertRule" in this.sheet ? this.sheet.insertRule(a + "{" + b + "}") : "addRule" in this.sheet && this.sheet.addRule(a, b);
    }

  }

  return class {
    constructor(b) {
      let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.version = a, this.loaded_at = new Date(), this.form = b, this.config = h(c), this.append_stylesheet(), this.obfuscate_field_names(), this.append_honeypot_fields(), this.append_timer_field(), this.append_version_field(), this.config.autobind ? void this.bind() : this.on_submit.bind(this);
    }

    bind() {
      this.form.addEventListener("submit", this.on_submit.bind(this));
    }

    append_stylesheet() {
      const a = new i(this.config.style.id);
      a.add_rule(`.${this.config.honeypot.field.class_name}`, `
        position: absolute;
        right: 200vw;
      `), a.add_rule(`.${this.config.honeypot.label.class_name}`, `
        position: absolute;
        right: 200vw;
      `);
    }

    obfuscate_field_names() {
      const a = this.form,
            c = Array.from(a.querySelectorAll("input:not([type=submit]),select,textarea"));
      c.forEach(a => {
        const c = a.id || a.name;
        if (!c) return void console.warn("Found field without name:", a);
        const d = this.form.querySelector(`label[for=${c}]`);
        d && d.classList.add(`${this.config.style.label_prefix}__${c}`), a.classList.add(`${this.config.style.field_prefix}__${c}`), a.name = b(a.name);
      });
    }

    append_honeypot_fields() {
      const a = d(this.config.honeypot.label),
            b = e(this.config.honeypot.field);
      this.form.appendChild(a), this.form.appendChild(b);
    }

    append_timer_field() {
      this.timer_field = f(this.config.honeypot.timer), this.form.appendChild(this.timer_field);
    }

    append_version_field() {
      this.version_field = g(this.config.honeypot.version), this.form.appendChild(this.version_field);
    }

    active_for() {
      return new Date() - this.loaded_at;
    }

    on_submit() {
      this.timer_field.value = this.active_for(), this.version_field.value = this.version;
    }

  };
});